<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'PAGES.BACKUPS.TITLE' | translate }}</glxy-page-title>
    <glxy-page-actions>
      @if (currentStagingStatus$ | async; as status) {
        <button
          mat-flat-button
          color="primary"
          (click)="showBackupNowDialog(status)"
          [disabled]="backupStatus !== 'done'"
          >
          <mat-icon>backup_table</mat-icon>{{ 'PAGES.BACKUPS.BUTTONS.BACKUP_NOW' | translate }}
        </button>
      }
      <a class="toolbar-help-button" mat-icon-button target="_blank" href="https://websitepro.zendesk.com/hc/en-us">
        <mat-icon>help_outline</mat-icon>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div class="backup-container">
      <mat-tab-group>
        <mat-tab [label]="'PAGES.BACKUPS.TABS.PRODUCTION' | translate">
          <ng-template matTabContent>
            <app-backup-table
              [isStaging]="false"
              (backupStatusChange)="onBackupStatusChange($event)"
              (upgradeButtonClicked)="showUpgradeCTA()"
            ></app-backup-table>
          </ng-template>
        </mat-tab>
        @if ((isExpress$ | async) || (isTemplate$ | async)) {
          <mat-tab disabled [label]="'PAGES.BACKUPS.TABS.STAGING' | translate">
            <ng-template mat-tab-label>
              <mat-icon>lock</mat-icon>
              {{ 'PAGES.BACKUPS.TABS.STAGING' | translate }}
            </ng-template>
          </mat-tab>
        } @else {
          <mat-tab [label]="'PAGES.BACKUPS.TABS.STAGING' | translate">
            <ng-template matTabContent>
              <app-backup-table [isStaging]="true"></app-backup-table>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </glxy-page-wrapper>
</glxy-page>
